import { render } from "./Reaction.vue?vue&type=template&id=507ed5c5&scoped=true"
import script from "./Reaction.vue?vue&type=script&lang=js"
export * from "./Reaction.vue?vue&type=script&lang=js"

import "./Reaction.vue?vue&type=style&index=0&id=507ed5c5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ed5c5"],['__file',"src/scripts/view/review/components/Reaction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "507ed5c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('507ed5c5', __exports__)) {
    api.reload('507ed5c5', __exports__)
  }
  
  module.hot.accept("./Reaction.vue?vue&type=template&id=507ed5c5&scoped=true", () => {
    api.rerender('507ed5c5', render)
  })

}


export default __exports__